/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type {
	CollectionView,
	ViewResponse,
} from '@jira/polaris__domain-collection/src/SrcViewResponse.tsx';

export const transformView = (view: ViewResponse): CollectionView => ({
	uuid: view.uuid,
	ownerId: view.owner,
	kind: view.visualizationType,
	title: view.name,
	emoji: view.emoji,
	description: view.description,
	apiResponse: view,
});
